/* ADEX combo upsell + same-car suggestion. Loads after adex.js.
   Intercepts add-to-cart in the capture phase so it can show a same-car
   combo popup, then falls through to the normal cart-drawer behaviour. */
(function () {
  "use strict";

  var CAR = { A90: "Supra", G90: "M5", F8X: "M3/M4", F87: "M2", G87: "M2", G20: "M340i", G8X: "M3/M4" };

  function classify(text) {
    var hay = " " + (text || "").toLowerCase() + " ";
    if (hay.indexOf("supra") > -1 || hay.indexOf("a90") > -1 || hay.indexOf("toyota") > -1) return "A90";
    if (hay.indexOf("g90") > -1 || hay.indexOf("g99") > -1 || hay.indexOf(" m5 ") > -1) return "G90";
    if (hay.indexOf("f80") > -1 || hay.indexOf("f82") > -1 || hay.indexOf("f8x") > -1) return "F8X";
    if (hay.indexOf("f87") > -1) return "F87";
    if (hay.indexOf("g87") > -1) return "G87";
    if (hay.indexOf("g20") > -1 || hay.indexOf("m340") > -1) return "G20";
    return "G8X";
  }

  function platformFor(btn) {
    var el = btn.closest("[data-platform]");
    if (el) return el.getAttribute("data-platform");
    var t = document.querySelector(".adex-pd__title");
    if (t) return classify(t.textContent);
    return null;
  }

  function cart() { return window.adexCart; }
  function toast(m) { if (window.adexToast) window.adexToast(m); }

  function inCart(c, id) {
    if (!c || !c.items) return false;
    id = String(id);
    return c.items.some(function (it) { return String(it.id) === id || String(it.variant_id) === id; });
  }
  function pick(platform, excludeId, c) {
    var list = (window.adexComboCatalog && window.adexComboCatalog[platform]) || [];
    for (var i = 0; i < list.length; i++) {
      var p = list[i];
      if (!p || !p.available) continue;
      if (String(p.id) === String(excludeId)) continue;
      if (inCart(c, p.id)) continue;
      return p;
    }
    return null;
  }
  function show(platform, excludeId, c) {
    var modal = document.querySelector("[data-combo]");
    if (!modal) return false;
    var p = pick(platform, excludeId, c);
    if (!p) return false;
    var carEl = modal.querySelector("[data-combo-car]");
    if (carEl) carEl.textContent = CAR[platform] || "carbon";
    var box = modal.querySelector("[data-combo-product]");
    if (box) {
      box.innerHTML = (p.img ? '<img src="' + p.img + '" alt="">' : "") +
        '<div><div class="t">' + p.title + '</div><div class="p">' + p.price + "</div></div>";
    }
    var add = modal.querySelector("[data-combo-add]");
    if (add) { add.setAttribute("data-variant-id", p.id); add.disabled = false; }
    modal.removeAttribute("hidden");
    return true;
  }
  function hide() { var m = document.querySelector("[data-combo]"); if (m) m.setAttribute("hidden", ""); }

  /* Intercept add-to-cart in CAPTURE phase, ahead of adex.js's bubble handler. */
  document.addEventListener("click", function (e) {
    var btn = e.target.closest("[data-add-to-cart]");
    if (!btn) return;
    if (btn.hasAttribute("data-no-combo")) return;
    if (!cart() || !window.adexComboCatalog) return;
    e.preventDefault();
    e.stopImmediatePropagation();

    var variantId = btn.getAttribute("data-variant-id");
    if (!variantId) return;
    var platform = platformFor(btn);
    var original = btn.innerHTML;
    btn.disabled = true;
    btn.innerHTML = '<svg class="adex-spin" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" width="16" height="16"><path d="M21 12a9 9 0 1 1-6.219-8.56"/></svg>';

    cart().add(variantId, 1)
      .then(function () { return cart().getJSON(); })
      .then(function (c) {
        cart().render(c);
        toast("Added to cart");
        if (!(platform && show(platform, variantId, c))) {
          cart().open();
        }
      })
      .catch(function (err) { toast((err && err.description) ? err.description : "Could not add to cart"); })
      .finally(function () { btn.disabled = false; btn.innerHTML = original; });
  }, true);

  /* Combo modal actions */
  document.addEventListener("click", function (e) {
    var modal = e.target.closest("[data-combo]");
    if (!modal) return;
    if (e.target.closest("[data-combo-add]")) {
      var add = modal.querySelector("[data-combo-add]");
      var vid = add.getAttribute("data-variant-id");
      if (!vid) return;
      add.disabled = true;
      cart().add(vid, 1)
        .then(function () { return cart().getJSON(); })
        .then(function (c) { cart().render(c); hide(); toast("Combo added — bundle discount applied at checkout"); cart().open(); })
        .catch(function () { toast("Could not add to cart"); add.disabled = false; });
      return;
    }
    if (e.target.closest("[data-combo-close]")) { hide(); cart().open(); }
  });
})();
